import toastr from 'toastr';

/**
 * General Pop Error fn using toastr
 *
 * @param {*} response - pass response object of axios to here, it will automatically pop error
 * @param {*} [cb] return the processed error msg so that can show to frontend
 */
export function popError(response, cb) {
  let errMsg;
  if (response && response.data) {
    if (response.data.msg) {
      if (typeof response.data.msg === 'string') {
        errMsg = response.data.msg;
      }
      else {
        errMsg = JSON.stringify(response.data.msg);
      }
    }
    else {
      if (typeof response.data === 'string') {
        errMsg = response.data;
      }
      else {
        errMsg = JSON.stringify(response.data);
      }
    }
  }
  else {
    if (response.status) {
      if (response.status === -1) {
        errMsg = 'Your internet connection is unstable, please try again';
      }
      else {
        errMsg = `${response.status} ${response.statusText}`;
      }
    }
    else {
      errMsg = response;
    }
  }
  if (errMsg !== 'MY_TUKAR_MSG') {
    toastr.warning(errMsg);
  }
  if (cb) {
    cb(errMsg);
  }
}

/**
 * This fn is used to pop error
 *
 * @param {string} errMsg the err msg in string
 */
export function popWarning(errMsg) {
  toastr.warning(errMsg);
}

/**
 * This fn is used to pop success msg
 *
 * @param {string} errMsg the success msg in string
 */
export function popSuccess(errMsg) {
  toastr.success(errMsg);
}

/**
 * If in demo environment, it will autofill the username & pass
 *
 * @returns {boolean} the value compiled by define plugin
 */
export function isDEMO() {
  // eslint-disable-next-line no-undef
  return IS_DEMO;
}

/**
 * Generate recaptcha token
 *
 * @param {*} cb callback
 */
export function generateRecaptchaToken(cb) {
  // eslint-disable-next-line no-undef
  grecaptcha.ready(function() {
    // eslint-disable-next-line no-undef
    grecaptcha.execute('6LdRWgcfAAAAADzFNaSjHSZ-r0awNVGNuGzaNzcr', {action: 'submit'}).then(function(token) {
      // Add your logic to submit to your backend server here.
      cb(null, token);
    });
  });
}

/**
 * Check if the object is array and the array is not empty array
 *
 * @param {object} obj - the object to be tested
 * @returns {boolean} a boolean which tell you if it's empty array
 */
export function isNotEmptyArray(obj) {
  return !!(obj && Array.isArray(obj) && obj.length > 0);
}

/**
 * Check if user allow to use voucher service, default is true
 * @param {{voucher:boolean}} userData
 * @returns {boolean}
 */
export function isAllowVoucher(userData) {
  let allowVoucher = true;
  if (userData.voucher === false) {
    allowVoucher = false;
  }
  return allowVoucher;
}

/**
 * Check if user allow to use voucher service, default is true
 * @param {{voucher:boolean}} userData
 * @returns {boolean}
 */
export function isAllowWarranty(userData) {
  let allowVoucher = true;
  if (userData.warranty === false) {
    allowVoucher = false;
  }
  return allowVoucher;
}
